import { useEffect } from "react";
import { disablePushSubscription, syncPushSubscription } from "@/lib/pushNotifications";
import {
  disableNativePushSubscription,
  isNativePushSupported,
  syncNativePushSubscription,
} from "@/lib/nativePushNotifications";
import { readStoredSettings } from "@/lib/userSettings";

const NATIVE_PUSH_PROMPTED_KEY = "lotq_native_push_permission_prompted";

export default function usePushNotifications(user) {
  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!user || !token) return undefined;

    const settings = readStoredSettings();
    if (isNativePushSupported()) {
      if (settings.browserNotifications === true) {
        const requestedBefore = localStorage.getItem(NATIVE_PUSH_PROMPTED_KEY) === "true";
        if (!requestedBefore) localStorage.setItem(NATIVE_PUSH_PROMPTED_KEY, "true");
        syncNativePushSubscription(token, { requestPermission: !requestedBefore }).catch(() => {});
      } else {
        disableNativePushSubscription(token).catch(() => {});
      }
      return undefined;
    }

    if (settings.browserNotifications === true && typeof Notification !== "undefined" && Notification.permission === "granted") {
      syncPushSubscription(token).catch(() => {});
    } else if (settings.browserNotifications !== true) {
      disablePushSubscription(token).catch(() => {});
    }

    return undefined;
  }, [user]);
}
